import config from "../../config";
import Router from '../../router'; 
import axios from "axios";

var $token;

var axiosInstance = axios.create({
    baseURL: config.API_BASE,
    timeout: 5000
})

axiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if(error.response.status == 401) {
        return logout()
    }

    return Promise.reject(error);
});

function logout(){
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    Router.push('/login')
}

export function api(){
    if(!$token) {
        if(!localStorage.token){
            return logout()
        }

        try {
            $token = localStorage.token
        } catch (error) {
            return logout()
        }
    }

    axiosInstance.interceptors.request.use(function (config) {
        config.headers.Authorization = `Bearer ${$token}`;
    
        return config;
    });

    return axiosInstance
}

export async function auth(username, password){
    let response = await axios.post(`${config.API_BASE}/login`, {
        usu_login: username,
        password: password
    })
    
    if(!response) {
        return false
    }

    $token = response.data.access_token
    localStorage.setItem('token', response.data.access_token)

    return true
}